import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { catchError, map, mergeMap, of, startWith } from 'rxjs';
import { AuthActions } from '@components/auth/auth.actions';
import { ReportViewTraitActions } from './trait.actions';
import { selectReportViewTraitFilters } from './trait.selectors';
import { ReportViewTraitService } from './trait.service';

/**
 * @description Report View Trait Effects.
 * @exports
 * @class ReportViewTraitEffects
 */
@Injectable()
export class ReportViewTraitEffects extends ReportViewTraitService {
  private readonly actions = inject(Actions);
  private readonly store = inject(Store);

  readonly onAuthLogout_SwitchProfile = createEffect(
    () => {
      return this.actions.pipe(
        ofType(AuthActions.logout, AuthActions.switchProfile),
        map(() => ReportViewTraitActions.reset())
      );
    },
    { dispatch: true }
  );

  readonly onFetchTrait = createEffect(
    () => {
      return this.actions.pipe(
        ofType(ReportViewTraitActions.fetchTrait),
        concatLatestFrom(() => this.store.select(selectReportViewTraitFilters)),
        mergeMap(([, filters]) => {
          return this.findAllBiReports(filters).pipe(
            mergeMap((data) =>
              of(
                ReportViewTraitActions.setTrait({
                  count: data.count,
                  results: data.results
                }),
                ReportViewTraitActions.setTraitLoading({ loading: false })
              )
            ),
            catchError((error) => {
              // eslint-disable-next-line no-console
              console.error('onFetchTrait', error);
              return of(
                ReportViewTraitActions.setTrait({
                  count: 0,
                  results: []
                }),
                ReportViewTraitActions.setTraitLoading({ loading: false })
              );
            }),
            startWith(ReportViewTraitActions.setTraitLoading({ loading: true }))
          );
        })
      );
    },
    { dispatch: true }
  );
}
